function SuperFastOrderController ( SuperFastOrderService )
{
    "ngInject";

    var vm = this;

    vm.superFastOrder = SuperFastOrderService;
}

module.exports = SuperFastOrderController;